<template>
  <footer class="relative bg-slate-200 pb-6 pt-20">
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap text-center lg:text-left">
        <div class="w-full px-4 lg:w-4/12">
          <h4 class="text-3xl font-semibold text-black">
            Connect with us
          </h4>
          <div class="my-6 lg:mb-0">
            <a
              href="mailto:support@rackmanage.io"
              aria-label="Email"
              class="inline-flex mr-2 size-10 items-center justify-center rounded-full bg-white font-normal
                text-slate-800 shadow-lg"
            >
              <i
                class="fa-solid fa-envelope"
                aria-hidden="true"
              />
            </a>
            <a
              href="https://github.com/RackManage"
              aria-label="GitHub"
              class="inline-flex mr-2 size-10 items-center justify-center rounded-full bg-white font-normal
                text-slate-800 shadow-lg"
            >
              <i
                class="fa-brands fa-github"
                aria-hidden="true"
              />
            </a>
          </div>
        </div>
        <div class="w-full px-4 lg:w-4/12">
          <div class="my-6 flex flex-wrap justify-center lg:mb-0">
            <iframe
              title="Rack Manage System Status"
              src="https://rackmanage.instatus.com/embed-status/3397283d/light-lg"
              width="100%"
              height="61"
              frameBorder="0"
              scrolling="no"
              style="border: none; max-width: 500px;"
              credentialless
              referrerpolicy="no-referrer"
            />
          </div>
        </div>
        <div class="w-full px-4 lg:w-4/12">
          <div class="items-top mb-6 flex flex-wrap">
            <div class="ml-auto w-full px-4 lg:w-4/12">
              <ul class="list-unstyled m-0">
                <li>
                  <a
                    class="block pb-2 text-sm font-semibold text-slate-800 hover:text-black"
                    href="/"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    class="block pb-2 text-sm font-semibold text-slate-800 hover:text-black"
                    href="/#features"
                  >
                    Features
                  </a>
                </li>
                <li>
                  <a
                    class="block pb-2 text-sm font-semibold text-slate-800 hover:text-black"
                    href="/pricing"
                  >
                    Pricing
                  </a>
                </li>
                <li>
                  <a
                    class="block pb-2 text-sm font-semibold text-slate-800 hover:text-black"
                    href="https://support.rackmanage.io/"
                  >
                    Support
                  </a>
                </li>
              </ul>
            </div>
            <div class="w-full px-4 lg:w-4/12">
              <ul class="list-unstyled m-0">
                <li>
                  <a
                    class="block pb-2 text-sm font-semibold text-slate-800 hover:text-black"
                    href="https://rackmanage.featurebase.app/?createPost=true"
                  >
                    Feedback
                  </a>
                </li>
                <li>
                  <a
                    id="report-bug-button"
                    class="block pb-2 text-sm font-semibold text-slate-800 hover:text-black"
                    href="javascript:void(0)"
                  >
                    Report Bug
                  </a>
                </li>
                <li>
                  <a
                    class="block pb-2 text-sm font-semibold text-slate-800 hover:text-black"
                    href="/privacy"
                  >
                    Privacy Policy
                  </a>
                </li>
                <a-dropdown
                  :trigger="['click']"
                  placement="topLeft"
                  @visible-change="isActive = $event"
                >
                  <li class="m-0 list-none">
                    <a
                      class="decoration-none block pb-2 text-sm font-semibold text-slate-800 hover:text-black"
                      href="#"
                      @click.prevent
                    >
                      Legal
                      <i
                        class="fa-solid fa-caret-right ml-1 transition-transform duration-200"
                        :class="{ '-rotate-90': isActive }"
                      />
                    </a>
                  </li>
                  <template #overlay>
                    <a-menu>
                      <a-menu-item>
                        <a href="/privacy">Privacy Policy</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a href="/terms">Terms of Service</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a href="/subprocessors">Sub-Processors</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a href="/cookies">Cookie Policy</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a
                          onclick="javascript:CookieScript.instance.show()"
                          href="javascript:void(0)"
                        >
                          Cookie Preferences
                        </a>
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <hr class="my-6 border-slate-300">
      <div
        class="flex flex-wrap items-center justify-center md:justify-between"
      >
        <div class="mx-auto w-full px-4 text-center md:w-4/12">
          <div class="py-1 text-sm font-semibold text-slate-600">
            <p>© {{ date }} Rack Manage. All rights reserved.</p>
            <p class="mt-2">
              A <a
                href="https://www.nuovar.com/?utm_source=rackmanage&utm_medium=footer"
                class="text-slate-800 hover:text-black"
              >Nuovar</a> Product
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
import { getClient } from '@sentry/browser';
import { onMounted, ref } from 'vue';

const date = new Date().getFullYear();
const isActive = ref(false);

onMounted(() => {
  const client = getClient();
  const feedback = client?.getIntegrationByName('Feedback');
  if (feedback) {
    // @ts-expect-error - Feedback integration has attachTo method
    feedback.attachTo(document.querySelector('#report-bug-button'));
  }
});
</script>
